import { RootState } from '@app/redux/root-reducer';

export const selectSkuBannerState = (store: RootState) => store.skuBannerSlice.skuBanner;
export const selectAddNewSkuProductState = (store: RootState) =>
  store.skuBannerSlice.addNewSkuProduct;
export const selectDeleteBannerState = (store: RootState) => store.skuBannerSlice.deleteSkuBanner;
